export default __webpack_public_path__ + "static/media/p02 p02.29dd40bf.jpg";